import { CheckCircleOutlineRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import { black, greyEnabled, purple, purpleLight } from "../../../../theme/colors";

interface Props {
  open: boolean;
  languageName?: string;
  onClose: () => void;
  onConfirm: () => void;
  submitting?: boolean;
}

export default function ApproveTranslationDialog({
  open,
  languageName,
  onClose,
  onConfirm,
  submitting = false,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={() => !submitting && onClose()}
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogContent
        sx={{
          width: 400,
          maxWidth: "90vw",
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: purpleLight,
            mb: 2,
          }}
        >
          <CheckCircleOutlineRounded sx={{ color: purple, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Approve this translation?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          Are you sure you want to approve the{languageName ? ` ${languageName}` : ""} translation
          for this scheme?
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            disabled={submitting}
            onClick={onClose}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            No
          </Button>
          <Button
            fullWidth
            disabled={submitting}
            onClick={onConfirm}
            variant="contained"
            disableElevation
            startIcon={
              submitting ? (
                <CircularProgress size={16} sx={{ color: "#fff" }} />
              ) : undefined
            }
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
